export default __webpack_public_path__ + "static/media/sticker-wa.39dacad6.png";